module.exports = __webpack_public_path__ + "slider-01.jpg?b70fd095e6a235a89ea72d0e006d905f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-01.jpg
// module id = 263
// module chunks = 0